<template>
  <div class="search-results">
    <div class="filters-section">
      <DateDropdown />
      <SchoolsDropdown />
      <TypeDropdown />
    </div>
    <div class="results-section">
      <div v-if="isLoading">
        <BaseCardSkeleton
          v-for="n in 3"
          :key="`skeleton-${n}`"
        />
      </div>
      <div
        v-else-if="results.length === 0"
        class="no-results"
      >
        <span class="error-message">{{ $t('search.noResultsFor', { searchTerm: route.query.q }) }}</span>
        <span class="try-again-message">{{ $t('search.clearFiltersAndSearchAgain') }}</span>
      </div>
      <ResultsSection
        v-else
        :results="results"
      />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import BaseCardSkeleton from './ResultCards/BaseCardSkeleton.vue';
import ResultsSection from './ResultsSection.vue';
import DateDropdown from './SearchFilters/DateDropdown.vue';
import SchoolsDropdown from './SearchFilters/SchoolsDropdown.vue';
import TypeDropdown from './SearchFilters/TypeDropdown.vue';

const route = useRoute();

defineProps({
  results: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});
</script>

<style lang="scss" scoped>
.search-results {
  --color-text-primary: #2d2d2d;

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 100%;
  background: var(--primary-white);
  border-radius: 8px;
  height: auto;
  max-height: 584px;
  overflow-y: auto;
}

.no-results {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px;
  font-family: 'Inter';
  font-size: 14px;
  font-weight: 450;
  line-height: 16px;
  letter-spacing: 0.5px;
  color: #222;
  height: 240px;
  .error-message {
    color: var(--color-text-primary);
    font-size: 16px;
    font-weight: 700;
    line-height: 120%;
    letter-spacing: 0.8px;
  }
  .try-again-message {
    color: var(--color-text-primary);
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 22px;
    letter-spacing: 0.6px;
  }
}
.filters-section {
  display: flex;
  gap: 12px;
}
.results-section {
  gap: 16px;
  display: flex;
  flex-direction: column;
  margin-top: 24px;
}
</style>
